import {
  SHOW_POI_DETAIL,
  SHOW_POI_ROUTE,
  SHOW_ADD_POI,
  SHOW_FOLDER_DETAIL,
  SCROLL_TO_DAY,
  VIEW_STATE,
  SHOW_EDIT_MODE,
  RESET_ITINERARY,
  SHOW_TOAST,
  SHOW_DAY_MODE_ON_MAP,
  // card indicator
  FETCH_POIS_SUCCESS,
  UPDATE_TRIP_INFO,
  UPDATE_TRIP_INFO_SUCCESS,
  UPDATE_TRIP_INFO_FAIL,
  REINDEX_DAY_SEQUENCE,
  REINDEX_DAY_SEQUENCE_SUCCESS,
  REINDEX_DAY_SEQUENCE_FAIL,
  REINDEX_POI_SEQUENCE,
  REINDEX_POI_SEQUENCE_SUCCESS,
  REINDEX_POI_SEQUENCE_FAIL,
  COPY_POI,
  COPY_POI_SUCCESS,
  COPY_POI_FAIL,
  REMOVE_POIS,
  REMOVE_POIS_SUCCESS,
  REMOVE_POIS_FAIL,
  REMOVE_DAYS,
  REMOVE_DAYS_SUCCESS,
  REMOVE_DAYS_FAIL,
  ADD_TRIP,
  ADD_TRIP_SUCCESS,
  ADD_TRIP_FAIL,
  COPY_TRIP,
  COPY_TRIP_SUCCESS,
  COPY_TRIP_FAIL,
  // request fail
  EDIT_ALIAS_NAME_FAIL,
  UPDATE_START_TIME_FAIL,
  UPDATE_STAY_TIME_FAIL,
  DELETE_TRIP_FAIL,
  DELETE_SHARED_TRIP_FAIL,
  ACCEPT_SEND_ITINERARY_SUCCESS,
  ACCEPT_SEND_ITINERARY_FAIL,
  ACCEPT_SHARED_TRIP_SUCCESS,
  ACCEPT_SHARED_TRIP_FAIL,
  CUSTOMIZE_TRANSPORTATION_TIME_FAIL,
  FETCH_MY_COLLECTIONS_FAIL,
  FETCH_SHARED_COLLECTIONS_FOLDERS_FAIL,
  FETCH_MY_COLLECTIONS_IN_FOLDER_FAIL,
  ADD_POI_TO_COLLECTIONS_FAIL,
  ADD_POI_TO_COLLECTIONS_SUCCESS,
  ADD_POI_SUCCESS, // for dismiss route
  ADD_POI_FAIL,
  GEO_CODE_FAIL,
  CHANGE_TRANSPORTATION_TYPE,
  CHANGE_TRANSPORTATION_TYPE_SUCCESS,
  CHANGE_TRANSPORTATION_TYPE_FAIL,
  FETCH_TRIPS_COMMENTS_FAIL,
  RESET_RECOMMENDED_POI,
  USER_LOG_OUT,
  HIDDEN_TOAST,
  SET_POI_DETAIL_TAB,
  SHOW_ORDER_DETAIL,
  SHOW_NOTE_DETAIL,
  RESET_DATE_OUT_STATUS,
  POST_TEXT_NOTE_FAIL,
  LISTEN_CONNECT_REVISION,
  MORE_DAYS,
  MORE_DAYS_SUCCESS,
  MORE_DAYS_FAIL,
} from './../actions/action_types';

const initState = {
  isShowPoiDetail: {
    isShow: false,
    poiObjectId: null,
    folderObjectId: null,
    type: null,
    dataSource: null,
  },
  isShowRoute: { isShow: false, poiObjectId: null },
  isShowAddPoi: { isShow: false, tripObjectId: null },
  isShowFolderDetail: { isShow: false, folderObjectId: null },
  isShowOrderCard: { isShow: false, orderId: null, poiObjectId: null },
  isShowEcNote: { isShow: false, poiObjectId: null },
  isEditMode: false,
  itineraryScrollTo: 1,
  showDayMode: null,
  viewState: { parameters: {} },
  showToast: { revision: null, message: null },
  selectedSegmentIndex: 0,
  // indicator
  showCardIndicator: false,
  status: '0',
};

export default (state = { ...initState }, action) => {
  const { type, payload } = action;
  // console.log('view state reducer = ', type);
  switch (type) {
    case SHOW_POI_DETAIL:
      return {
        ...state,
        isShowPoiDetail: {
          isShow: payload.show,
          poiObjectId: payload.poiObjectId,
          folderObjectId: payload.folderObjectId,
          type: payload.type,
          dataSource: payload.dataSource,
          location: payload.location,
        },
        isShowPoiRoute: { isShow: false, poiObjectId: null },
        isShowOrderCard: { isShow: false, orderId: null, poiObjectId: null },
        isShowEcNote: { isShow: false, poiObjectId: null },
        showDayMode: null,
        selectedSegmentIndex: payload.segmentIndex || 0,
      };
    case SHOW_POI_ROUTE:
      return {
        ...state,
        isShowRoute: { isShow: payload.show, poiObjectId: payload.selectedId },
        isShowPoiDetail: {
          isShow: false,
          poiObjectId: null,
          type: null,
          dataSource: null,
        },
        isShowOrderCard: { isShow: false, orderId: null, poiObjectId: null },
        isShowEcNote: { isShow: false, poiObjectId: null },
        isShowAddPoi: { isShow: false, tripObjectId: null },
        showDayMode: null,
      };
    case SHOW_ORDER_DETAIL:
      return {
        ...state,
        isShowOrderCard: {
          isShow: payload.isShowOrderCard,
          orderId: payload.orderId,
          poiObjectId: payload.poiObjectId,
        },
        isShowPoiDetail: {
          isShow: false,
          poiObjectId: null,
          folderObjectId: null,
          type: null,
          dataSource: null,
        },
      };
    case SHOW_NOTE_DETAIL:
      return {
        ...state,
        isShowEcNote: {
          isShow: payload.isShowNoteDetail,
          poiObjectId: payload.poiObjectId,
        },
        isShowOrderCard: { isShow: false, orderId: null, poiObjectId: null },
        isShowPoiDetail: {
          isShow: false,
          poiObjectId: null,
          folderObjectId: null,
          type: null,
          dataSource: null,
        },
      };
    case SHOW_ADD_POI:
      return {
        ...state,
        isShowAddPoi: {
          isShow: payload.show,
          tripObjectId: payload.tripObjectId,
        },
        isShowPoiRoute: { isShow: false, poiObjectId: null },
        isShowPoiDetail: {
          isShow: false,
          poiObjectId: null,
          type: null,
          dataSource: null,
        },
        isShowOrderCard: { isShow: false, orderId: null, poiObjectId: null },
        isShowEcNote: { isShow: false, poiObjectId: null },
        showDayMode: null,
      };
    case SHOW_EDIT_MODE:
      return {
        ...state,
        isEditMode: !state.isEditMode,
        isShowRoute: { isShow: false, poiObjectId: null },
        isShowOrderCard: { isShow: false, orderId: null, poiObjectId: null },
        isShowEcNote: { isShow: false, poiObjectId: null },
        isShowPoiDetail: {
          isShow: false,
          poiObjectId: null,
          type: null,
          dataSource: null,
        },
        showDayMode: null,
      };
    case SET_POI_DETAIL_TAB:
      return {
        ...state,
        selectedSegmentIndex: payload.segmentIndex,
      };
    case RESET_ITINERARY:
      return {
        ...state,
        isEditMode: false,
        isShowAddPoi: {
          isShow: false,
          tripObjectId: null,
        },
        isShowRoute: { isShow: false, poiObjectId: null },
        isShowOrderCard: { isShow: false, orderId: null, poiObjectId: null },
        isShowEcNote: { isShow: false, poiObjectId: null },
        isShowPoiDetail: {
          isShow: false,
          poiObjectId: null,
          type: null,
          dataSource: null,
        },
        showDayMode: null,
      };
    case RESET_RECOMMENDED_POI:
      return {
        ...state,
        isShowPoiDetail: {
          isShow: false,
        },
      };
    case SHOW_DAY_MODE_ON_MAP:
      return {
        ...state,
        showDayMode: state.showDayMode === payload ? null : payload,
        isShowPoiDetail: {
          isShow: false,
          poiObjectId: null,
          type: null,
          dataSource: null,
        },
        isShowRoute: { isShow: false, poiObjectId: null },
      };
    case SHOW_FOLDER_DETAIL:
      // console.log(' show folder detail');
      // console.log(' payload ', payload);
      return {
        ...state,
        isShowFolderDetail: {
          isShow: payload.show,
          folderObjectId: payload.folderObjectId,
        },
      };
    case SCROLL_TO_DAY:
      return {
        ...state,
        itineraryScrollTo: payload.day,
      };
    case VIEW_STATE:
      return {
        ...state,
        viewState: {
          state: payload.viewState,
          parameters: payload.parameters,
        },
        showToast: { revision: null, message: null },
      };
    case ADD_POI_SUCCESS:
      return {
        ...state,
        isShowAddPoi: { isShow: false, tripObjectId: null },
        isShowPoiDetail: {
          isShow: false,
          poiObjectId: null,
          folderObjectId: null,
          type: null,
          dataSource: null,
        },
      };
    // show card indicator on the itinerary page
    case UPDATE_TRIP_INFO:
    case REINDEX_DAY_SEQUENCE:
    case REINDEX_POI_SEQUENCE:
    case COPY_POI:
    case REMOVE_POIS:
    case REMOVE_DAYS:
    case ADD_TRIP:
    case COPY_TRIP:
    case CHANGE_TRANSPORTATION_TYPE:
    case MORE_DAYS:
      return {
        ...state,
        showCardIndicator: true,
      };
    // dismiss card indicator on the itinerary page
    case FETCH_POIS_SUCCESS:
    case UPDATE_TRIP_INFO_SUCCESS:
    case REINDEX_DAY_SEQUENCE_SUCCESS:
    case REINDEX_POI_SEQUENCE_SUCCESS:
    case COPY_POI_SUCCESS:
    case REMOVE_POIS_SUCCESS:
    case REMOVE_DAYS_SUCCESS:
    case COPY_TRIP_SUCCESS:
    case ADD_TRIP_SUCCESS:
    case CHANGE_TRANSPORTATION_TYPE_SUCCESS:
    case MORE_DAYS_SUCCESS:
      return {
        ...state,
        showCardIndicator: false,
        isShowOrderCard: { isShow: false, orderId: null, poiObjectId: null },
      };
    // show toast
    case EDIT_ALIAS_NAME_FAIL:
    case UPDATE_START_TIME_FAIL:
    case UPDATE_STAY_TIME_FAIL:
    case REINDEX_DAY_SEQUENCE_FAIL:
    case DELETE_TRIP_FAIL:
    case DELETE_SHARED_TRIP_FAIL:
    case ACCEPT_SEND_ITINERARY_SUCCESS:
    case ACCEPT_SEND_ITINERARY_FAIL:
    case ACCEPT_SHARED_TRIP_SUCCESS:
    case ACCEPT_SHARED_TRIP_FAIL:
    case CUSTOMIZE_TRANSPORTATION_TIME_FAIL:
    case FETCH_MY_COLLECTIONS_FAIL:
    case FETCH_SHARED_COLLECTIONS_FOLDERS_FAIL:
    case FETCH_MY_COLLECTIONS_IN_FOLDER_FAIL:
    case ADD_POI_TO_COLLECTIONS_FAIL:
    case ADD_POI_TO_COLLECTIONS_SUCCESS:
    case FETCH_TRIPS_COMMENTS_FAIL:
    case ADD_POI_FAIL:
    case SHOW_TOAST:
    case POST_TEXT_NOTE_FAIL:
    case CHANGE_TRANSPORTATION_TYPE_FAIL:
    case LISTEN_CONNECT_REVISION:
      return {
        ...state,
        showToast: {
          revision: new Date().toString(),
          message: payload ? payload.toastMessage : null,
          viewState: payload ? payload.toastViewState : null,
        },
        status: payload.status || '0',
      };
    // show toast and dismiss indicator
    case UPDATE_TRIP_INFO_FAIL:
    case REINDEX_POI_SEQUENCE_FAIL:
    case COPY_POI_FAIL:
    case REMOVE_POIS_FAIL:
    case REMOVE_DAYS_FAIL:
    case COPY_TRIP_FAIL:
    case ADD_TRIP_FAIL:
    case GEO_CODE_FAIL:
    case MORE_DAYS_FAIL:
      return {
        ...state,
        showCardIndicator: false,
        showToast: {
          revision: new Date().toString(),
          message: payload ? payload.toastMessage : null,
          viewState: payload ? payload.toastViewState : null,
        },
        status: payload.status || '0',
      };
    case RESET_DATE_OUT_STATUS:
      return {
        ...state,
        status: '0',
      };
    case USER_LOG_OUT:
      return {
        ...initState,
      };
    case HIDDEN_TOAST:
      return {
        ...state,
        showToast: {
          revision: null,
          message: null,
        },
      };
    default:
      return state;
  }
};
